export enum EPanoramaStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  NotFound = 'notFound',
  Unsupported = 'unsupported',
  Failed = 'failed',
}
